module.exports = __webpack_public_path__ + "static/media/IMG2.933b8ca1.png";